import { Box } from '@mui/material';

export const BioMedicalEngineering = () => {
  return <Box sx={{ flex: 1 }}>BioMedical Engineering</Box>;
};
